import { render, staticRenderFns } from "./capacitiesDashboard.vue?vue&type=template&id=601106b8&"
import script from "./capacitiesDashboard.vue?vue&type=script&lang=js&"
export * from "./capacitiesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports